<div class="card">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">

        <!-- Title -->

        <div class="input-group">

          <input [formControl]="searchControl" class="form-control form-control-flush" placeholder="Tapez ici..."
            type="search">
          <!--                        <label class="form-label" for="form1">Search</label>-->

          <button (click)="this.search()" class="btn btn-primary" type="button">
            <i class="fas fa-search"></i>
          </button>
        </div>


      </div>

      <div class="col-auto">
        @if (this.state === 'REFRESHING' || this.state === 'LOADING') {
          <span class="text-muted me-3"><i
          class="fas fa-sync fa-spin"></i> Actualisation en cours</span>
        }
        @if (this.showHasBeenRefreshed) {
          <span class="text-muted me-3">Actualisé</span>
        }

        <a (click)="this.refreshClicked.emit(); $event.preventDefault()" class="btn btn-link" href="">
          Actualiser
        </a>

        <!-- Button -->
        @for (action of actions; track action) {
          <button (click)="this.actionClicked.emit(action.keyname)"
            [className]="action.cssClasses"
            role="button">
            {{ action.displayText }}
          </button>
        }

      </div>
    </div> <!-- / .row -->
  </div>
  <table [class.table-loading]="state === 'LOADING'"

    [class.table-no-data]="state === 'NO_DATA'"
    [class.table-refreshing]="state === 'REFRESHING'"
    class="table table-sm">
    <thead>
      <tr>
        @for (column of columns; track column) {
          <th scope="col">
            <a (click)="this.columnClicked(column); $event.preventDefault()" [class.list-sort]="column.isSortable"
              [class.pe-none]="column.isSortable === false"
              href="#">
              @if (column.isSortable && this.sortBy != column.keyname) {
                <span class="text-muted"><i
                class="fa fa-sort"></i></span>
              }
              @if (this.sortBy === column.keyname && this.order === 'asc') {
                <span><i
                class="fas fa-caret-up"></i></span>
              }
              @if (this.sortBy === column.keyname && this.order === 'desc') {
                <span><i
                class="fas fa-caret-down"></i></span>
              }
              <span class="text-muted ms-2">{{ column.displayText }}</span>
            </a>
          </th>
        }
      </tr>
    </thead>
    @if (this.state === 'LOADING') {
      <tbody>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
        <tr>
          <td class="td-3"><span></span></td>
          <td class="td-4"></td>
          <td class="td-5"><span></span></td>
        </tr>
      </tbody>
    }

    <ng-content></ng-content>

    <tfoot class="bg-light">
      <tr>
        <td [colSpan]="columns.length">


          <div class="d-flex flex-row-reverse align-items-center">
            <div class="ms-3">
              @if (numberOfResultsReturned !== 0) {
                <span>
                  <strong>{{ (page - 1) * maximumNumberOfResultsPerPage + 1 }}
                    - {{ (page - 1) * maximumNumberOfResultsPerPage + numberOfResultsReturned }}</strong> of <strong>{{ totalNumberOfResults }}</strong>
                  </span>
                }
                @if (numberOfResultsReturned === 0) {
                  <strong>Total: {{ totalNumberOfResults }}</strong>
                }
              </div>
              <nav aria-label="Page navigation example" class="align-self-center">
                <ul class="pagination m-0">
                  <li class="page-item">
                    <button (click)="pageSelected(this.page - 1)" [class.disabled]="this.page === 1" aria-label="Previous"
                      class="page-link">
                      <span aria-hidden="true">&laquo;</span>
                    </button>
                  </li>
                  @for (i of this.pagesArray(); track i) {
                    <li [class.active]="i === this.page" class="page-item">
                      <button (click)="pageSelected(i)" class="page-link">{{ i }}</button>
                    </li>
                  }
                  <li [class.disabled]="this.page === this.totalNumberOfPages()" class="page-item">
                    <button (click)="pageSelected(this.page + 1)" aria-label="Next" class="page-link">
                      <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>